import { FC } from 'react';
import { DetailContainer, DetailValue, DetailTitle } from './styled';

type Props = {
  title: any;
  value: any;
};

const InfoItem: FC<Props> = ({ title, value = '—' }) => {
  return (
    <DetailContainer>
      <DetailTitle>{title}</DetailTitle>
      <DetailValue>{value}</DetailValue>
    </DetailContainer>
  );
};

export default InfoItem;
